<div class="main-content-wrappper">
  <div class="container-wrapper">
    <mat-tab-group
      *ngIf="mainBaseArray.length"
      [(selectedIndex)]="selected"
      (selectedTabChange)="clearPagination($event)">
      <mat-tab *ngFor="let item of mainBaseArray" [label]="item.name"></mat-tab>
    </mat-tab-group>

    <div class="faq-section" *ngIf="activeCategory as category">
      <div class="accordian-wrapper">
        <ul *ngIf="category.child.length > 0" aria-label="Subcategories">
          <li *ngFor="let childItem of category.child | paginate: { itemsPerPage: 10, currentPage: p }; index as i">
            <button type="button"
              class="faq-item-btn"
              [attr.id]="'kb-subcategory-item-' + i"
              [attr.aria-label]="'Browse ' + childItem.name + ' subcategory'"
              (click)="goToSubCategory(childItem.id, childItem.permalink)"
              (keydown)="onSubCategoryKeydown($event, i)">
              <span class="label">{{ childItem.name }}</span>
              <span class="icon-right-chevron" aria-hidden="true"></span>
            </button>
          </li>
        </ul>

        <ul *ngIf="category.child.length == 0" aria-label="Articles">
          <li *ngFor="let faq of faqArray | paginate: { itemsPerPage: 10, currentPage: pageNumber }; index as i">
            <button type="button"
              class="faq-item-btn"
              [attr.id]="'kb-faq-item-' + i"
              [attr.aria-label]="'Read article: ' + faq.title"
              (click)="goTosubCategoryAnswers(faq.id, faq.permalink, faq.title)"
              (keydown)="onFaqItemKeydown($event, i)">
              <span class="label">{{ faq.title }}</span>
              <span class="icon-right-chevron" aria-hidden="true"></span>
            </button>
          </li>
        </ul>
      </div>

      <pagination-controls
        *ngIf="category.child.length > 0"
        (pageChange)="p = $event"
        class="float-right"></pagination-controls>
      <pagination-controls
        *ngIf="category.child.length == 0"
        (pageChange)="pageNumber = $event"
        class="float-right"></pagination-controls>
    </div>
  </div>
</div>
